export enum LogMessageType {
  Simple = 'SIMPLE',
  Operation = 'OPERATION',
}
